import { render, staticRenderFns } from "./BettingPromotionsCard.vue?vue&type=template&id=42ac9f63"
import script from "./BettingPromotionsCard.vue?vue&type=script&lang=js"
export * from "./BettingPromotionsCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports